import React from 'react';

function ChatInterfaceIcon() {
  return (
    <svg
      width="17"
      height="15"
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.07031 11.5264C4.47656 11.2139 5.00781 11.1514 5.47656 11.3076C6.28906 11.6201 7.22656 11.7764 8.22656 11.7764C12.1016 11.7764 14.7266 9.27637 14.7266 6.77637C14.7266 4.30762 12.1016 1.77637 8.22656 1.77637C4.32031 1.77637 1.72656 4.30762 1.72656 6.77637C1.72656 7.77637 2.10156 8.74512 2.82031 9.58887C3.10156 9.87012 3.22656 10.2764 3.19531 10.6826C3.16406 11.2451 3.00781 11.7764 2.85156 12.2451C3.38281 11.9951 3.82031 11.7139 4.07031 11.5264ZM0.882812 12.7764C0.945312 12.7139 0.976562 12.6201 1.03906 12.5264C1.35156 12.0264 1.63281 11.3389 1.69531 10.5576C0.757812 9.49512 0.226562 8.21387 0.226562 6.77637C0.226562 3.21387 3.78906 0.276367 8.22656 0.276367C12.6328 0.276367 16.2266 3.21387 16.2266 6.77637C16.2266 10.3701 12.6328 13.2764 8.22656 13.2764C7.03906 13.2764 5.94531 13.0889 4.94531 12.7451C4.60156 12.9951 3.97656 13.3701 3.25781 13.6826C2.78906 13.9014 2.25781 14.0889 1.69531 14.1826C1.66406 14.1826 1.63281 14.2139 1.63281 14.2139C1.47656 14.2451 1.35156 14.2451 1.19531 14.2764C1.03906 14.2764 0.882812 14.3076 0.695312 14.3076C0.507812 14.3076 0.320312 14.1826 0.257812 13.9951C0.164062 13.8076 0.226562 13.5889 0.351562 13.4326C0.476562 13.3076 0.601562 13.1826 0.695312 13.0264C0.757812 12.9326 0.820312 12.8701 0.851562 12.8076C0.851562 12.8076 0.851562 12.8076 0.851562 12.7764H0.882812Z"
        fill="#667085"
      />
    </svg>
  );
}
export default ChatInterfaceIcon;
